import {
  AdControlPropertyRequest,
  AdControlResponseMap,
  AdControlTypedRequest,
  AdType,
} from '@/entities/advertisement';
import { addQueryString } from '@/utils/url';
import axios from 'axios';

const adcontrolInstance = axios.create({
  baseURL: 'https://api-v2.adrop.io',
  headers: {
    Authorization: process.env.NEXT_PUBLIC_ADROP_KEY ?? '',
  },
});

// 제네릭 API 함수
export const adcontrolQueryRequest = <T extends AdType>(
  params: AdControlTypedRequest<T>
): Promise<{ data: AdControlResponseMap[T] }> => {
  const queryParams = {
    unit: params.unitId,
    uid: params.userId,
    pf: params.platform,
    lcl: params.locale,
    contextId: params.contextId,
    trackMode: params.trackMode,
  };

  return adcontrolInstance.get<AdControlResponseMap[T]>(`/request${addQueryString(queryParams)}`);
};

export const adcontrolPropertyMutationRequest = (params: AdControlPropertyRequest) =>
  adcontrolInstance.post('/property', { uid: params.uid, value: JSON.stringify(params.value) });
